import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Enable one-time purchase for specific content
 * Creates new Stripe product and price
 * Many one-time products per creator (one per content item)
 */
export const enableOneTimePurchaseRpcContract = rpcContract({
  name: "enable-one-time-purchase",
  paramsSchema: v.object({
    contentType: v.picklist(["post", "link"]),
    contentId: v.string(),
    priceCents: v.pipe(v.number(), v.minValue(100), v.maxValue(99999)),
    productName: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
    productDescription: v.optional(v.pipe(v.string(), v.maxLength(500))),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    productId: v.string(),
    stripeProductId: v.string(),
    stripePriceId: v.string(),
    priceCents: v.number(),
  }),
});

export type EnableOneTimePurchaseParams = v.InferOutput<(typeof enableOneTimePurchaseRpcContract)["paramsSchema"]>;
export type EnableOneTimePurchaseResult = v.InferOutput<(typeof enableOneTimePurchaseRpcContract)["resultSchema"]>;
